import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import About from './About';
import PaymentMethods from './PaymentMethods';
import hqLogo from '../../../images/logo-hqbeds.png';
import PhoneLink from '../../PhoneLink';
import EmailLink from '../../EmailLink';

const Footer = () => {
  const { t } = useTranslation();
  const property = useSelector(state => state.property);
  const application = useSelector(state => state.application);
  const {
    aboutCallInfoText,
    address,
    city,
    state,
    phoneNumber,
    email,
    config: { creditCardPaymentEnabled, bankTransferPaymentEnabled },
  } = property;
  const { widget } = application;
  const isWidget = widget === '1';

  if (!property.ready || isWidget) {
    return null;
  }

  return (
    <footer>
      <div className="row greydark">
        <div className="container">
          <div className="row px-5 px-md-4 pt-5 pb-0">
            <div className="col-12 col-md-7 col-lg-8 mb-4 overflow-hidden">
              <div className="about v-align">
                <div className="top">
                  <About text={aboutCallInfoText} />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-5 col-lg-4 mb-4 overflow-hidden">
              <div className="bottom">
                <h5 className="mb-3">{t('labels.contact')}</h5>
                <div className="col aboutContent">
                  {address && <div className="col row-fluid mt-2"><address>{address}{city && state && ` - ${city}/${state}`}</address></div>}
                  {phoneNumber && <div className="col row-fluid mt-3"><small>{t('labels.phone')}</small><br /><PhoneLink phone={phoneNumber} /></div>}
                  {email && <div className="col row-fluid mt-2"><small>{t('labels.email')}</small><br /><EmailLink email={email} /></div>}
                </div>
              </div>
            </div>
          </div>
          <div className="row greydark border-top px-5 px-md-4 pt-4 pb-0">
            <div className="col-12 col-md-4 col-lg-3 mb-4 overflow-hidden">
              <h5 className="text-center text-lg-left secure">
                {t('info.secureSite')}
              </h5>
            </div>
            <div className="col-12 col-md-4 col-lg-6 mb-4 overflow-hidden">
              <PaymentMethods
                creditCardPaymentEnabled={creditCardPaymentEnabled}
                bankTransferPaymentEnabled={bankTransferPaymentEnabled}
              />
            </div>
            <div className="col-12 col-md-4 col-lg-3 mb-n5 text-center overflow-hidden">
              <img className="logo-footer" src={hqLogo} alt="HQBeds" />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
